import CustomSegment from '@/components/CustomSegment';
import PageTitle from '@/components/PageTitle';
import { useSegment } from '@/hooks/useSegment';
import DashboardLayout from '@/layouts/DashboardLayout';
import type { SegmentedType } from '@/types/global.types';
import Filters from './Filters';
import InterviewScores from './InterviewScores';
import ScheduledInterviews from './ScheduledInterviews';

type InterviewSegmentType = 'interview-scheduled' | 'interview-score';

export default function Interviews() {
  const { segment, setSegment } = useSegment<InterviewSegmentType>(
    'recruitment-interviews',
    'interview-scheduled',
    false,
  );

  const SEGMENT_CONFIG: SegmentedType<InterviewSegmentType>[] = [
    {
      value: 'interview-scheduled',
      label: 'Scheduled Interviews',
      view: <ScheduledInterviews />,
    },
    {
      value: 'interview-score',
      label: 'Scores',
      view: <InterviewScores />,
    },
  ];

  const currentSegment = SEGMENT_CONFIG.find((s) => s.value === segment);

  return (
    <DashboardLayout title="Interviews">
      <PageTitle
        classNames={{ root: 'items-start' }}
        title="Interviews"
        items={[
          { title: 'Dashboard', path: '/admin/recruitment/dashboard' },
          { title: currentSegment?.label },
        ]}
      >
        <Filters type={segment} />
      </PageTitle>

      <CustomSegment
        config={SEGMENT_CONFIG}
        selected={segment}
        onChange={setSegment}
      />
      <div className="mt-5">{currentSegment?.view}</div>
    </DashboardLayout>
  );
}
